<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app :right="isRight">
      <v-list>
        <v-list-item class="px-2" to="/">
          <img
            height="50px"
            width="50px"
            class="mx-auto my-6"
            :src="require('@/assets/imgs/logo.svg')"
          />
        </v-list-item>
      </v-list>

      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item
          link
          v-for="(item, index) in items"
          :key="index"
          :to="{ name: item.item.link }"
        >
          <v-list-item-icon class="ma-2">
            <v-icon small>{{ item.item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t(`${item.item.title}`) }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <template v-slot:append> </template>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndDown" app light>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-2">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <div class="pa-2">
        <v-btn
          @click="handleChangeLanguage"
          block
          icon
          :title="$t('button.language')"
        >
          <v-icon>mdi-earth</v-icon>
        </v-btn>
      </div>

      <div class="pa-2">
        <v-btn @click="logout" block icon><i class="icon-logout"></i></v-btn>
      </div>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import cookie from "js-cookie";
import { mapGetters } from "vuex";
export default {
  props: {
    source: String,
  },
  computed: {
    ...mapGetters({
      items: "getRoutes",
    }),
    isRight() {
      if (cookie.get("language") === "ar") {
        return true;
      } else {
        return false;
      }
    },
  },
  data: () => ({
    dialog: false,
    drawer: true,
    group: null,
    // items: [
    //   {
    //     icon: "mdi-account-circle",
    //     link: "users",
    //     title: "users",
    //   },
    //   {
    //     icon: "mdi-post",
    //     link: "blogs",
    //     title: "blogs",
    //   },

    //   {
    //     icon: "mdi-tag",
    //     link: "tags",
    //     title: "tags",
    //   },
    //   {
    //     icon: "mdi-flag",
    //     link: "topics",
    //     title: "topics",
    //   },
    //   // {
    //   //   icon: "mdi-flag",
    //   //   link: "subjects",
    //   //   title: "subjects",
    //   // },
    //   {
    //     icon: "mdi-message",
    //     link: "contact-message",
    //     title: "contact_message",
    //   },
    //   {
    //     icon: "mdi-group",
    //     link: "teachers",
    //     title: "teachers",
    //   },

    //   { icon: "mdi-cog", link: "settings", title: "settings" },
    // ],
  }),
  methods: {
    handleChangeLanguage() {
      const lang = cookie.get("language");
      if (lang === "ar") {
        this.changeCookie("en");
      } else {
        this.changeCookie("ar");
      }
    },
    changeCookie(lang) {
      cookie.set("language", lang);
      window.location.reload();
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // In order to re-instantiate the vue-router object to avoid bugs
      });
    },
  },
};
</script>
